export const styles = {
  profileContainer: {
    padding: '20px 35px 20px 40px',
    height: 'calc(100vh - 72px)',
    backgroundColor: '#F9F9FF',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    '@media (max-height: 900px)': {
      height: '100%',
    },
  },

  profileContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '1100px',
    minHeight: '340px',
    margin: '30px 0',
    fontSize: '16px',
    backgroundColor: '#FFFFFF',
    padding: '30px 50px 30px 30px',
    borderRadius: '8px',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },

  profileTitle: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    fontSize: '32px',
    fontWeight: '800',
    margin: '18px 0 30px 0',
  },
  securityContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '1100px',
    margin: '30px 0',
    fontSize: '16px',
    backgroundColor: '#FFFFFF',
    padding: '40px 40px 16px 40px',
    borderRadius: '8px',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
}
